import { z } from 'zod';
/** The longest text people may send, in SMS parts (phones join them back into one). */
export const TEXT_MAX_PARTS = 6;
// GSM 03.38: the default alphabet (one septet each) and the extension table (two).
const GSM_BASIC = new Set('@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !"#¤%&\'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà');
const GSM_EXTENDED = new Set('^{}\\[~]|€\f');
/**
 * How many SMS parts a text takes: up to 160 characters in one, 153 a part
 * when longer; with a letter outside the GSM alphabet (Lithuanian ą, č, ę…)
 * 70, and 67 a part.
 */
export function textLength(body) {
    let septets = 0;
    let unicode = false;
    for (const char of body) {
        if (GSM_BASIC.has(char))
            septets += 1;
        else if (GSM_EXTENDED.has(char))
            septets += 2;
        else {
            unicode = true;
            break;
        }
    }
    // UCS-2 counts UTF-16 units: an emoji takes two.
    const [size, single, part] = unicode ? [body.length, 70, 67] : [septets, 160, 153];
    if (size === 0)
        return { parts: 0, left: single, unicode };
    if (size <= single)
        return { parts: 1, left: single - size, unicode };
    const parts = Math.ceil(size / part);
    return { parts, left: parts * part - size, unicode };
}
export const textBodySchema = z
    .string()
    .trim()
    .min(1, 'Write the text')
    .max(1000)
    .refine((body) => textLength(body).parts <= TEXT_MAX_PARTS, 'Too long for one text: shorten it');
/** A reply in a conversation. */
export const sendTextSchema = z.object({ body: textBodySchema });
/** A text to someone new (or a conversation found by their number). */
export const startTextSchema = z.object({
    /** One of our numbers, from the ones this person may text from. */
    numberId: z.uuid(),
    /** Theirs, as people write numbers in the number's country. */
    to: z.string().trim().min(2, 'Enter the number').max(32),
    body: textBodySchema,
});
